import React, { useState } from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';

function MemberRegistration({ history }) {
    const [credentials, setCredentials] = useState({        
        email: null,
        password: null,
        confpassword: null
    });

    const handleChange = (e, property) => {
        setCredentials({ ...credentials, [property]: e.target.value });
    };

    const handleRegistration = async () => {
        try {
            if (credentials.password !== credentials.confpassword) {
                alert("Passwords don't match.");
            } else {
                axios
                .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Customer/GetByEmail/` + credentials.email)
                .then((response) => {
                    if (response.data > 0) {
                        alert("Email already exists.");
                    } else {
                        history.push({
                            pathname: '/update-profile-new',
                            state: credentials
                        });
                    }
                });                
            }            
        } 
        catch (ex) {
            alert("Error...");
        }
    };

    return (
        <div>
            <div className="int-container">
                <div class="container">
                    <div class="form-container">
                        <div class="form-group">
                            <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Member Registration</h3>
                        </div>
                        <div class="form-group">
                            <input type="email" placeholder="Enter Email" required class="form-control" onChange={(e) => handleChange(e, "email")} />
                        </div>
                        <div class="form-group">
                            <input type="password" placeholder="Enter Password" class="form-control" onChange={(e) => handleChange(e, "password")} />
                        </div>
                        <div class="form-group">
                            <input type="password" placeholder="Confirm Password" class="form-control" onChange={(e) => handleChange(e, "confpassword")} />
                        </div>
                        <div class="form-group">
                            <button className="btn btn-block btn-primary" onClick={handleRegistration}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(MemberRegistration);